
/**
 * @private
 */
 export const ERROR_MESSAGES = {
    MISSING_PLACE_NAME: "Missing place name",
    MISSING_SPECIES_LIST_ID: "Missing species list id",
    MISSING_ASSET_ID: "Missing asset id",
}
